import { EmploymentContractEnum } from '@libs/types/src/user/enum/employment-contract.enum';
import { RuleObject, UserRuleUpsertInput } from '@it2go/types';

export function contractVisibility(contract: string | null | undefined): { workloadVisible: boolean, scopeOfWorkVisible: boolean } {
    let workloadVisible = false;
    let scopeOfWorkVisible = false;
    if (contract === EmploymentContractEnum.DPP) {
        workloadVisible = false;
        scopeOfWorkVisible = true;
    }
    if (contract === EmploymentContractEnum.HPP || contract === EmploymentContractEnum.DPC) {
        workloadVisible = true;
        scopeOfWorkVisible = false;
    }
    if (contract === EmploymentContractEnum.VOLUNTEER || contract === EmploymentContractEnum.EXT_ICO) {
        workloadVisible = false;
        scopeOfWorkVisible = false;
    }
    return { workloadVisible, scopeOfWorkVisible };
}

export function rulesWithKey(rules: RuleObject[] | null): (RuleObject & { key: string })[] {
    if (!rules) return [];

    const uniqueRulesMap = new Map<string, RuleObject & { key: string }>();

    rules.forEach(rule => {
        const key = `${rule.resource}::${rule.action}`;
        uniqueRulesMap.set(key, { ...rule, key });
    });
    return Array.from(uniqueRulesMap.values());
}

export function ruleFromKey(key: string): UserRuleUpsertInput {
    return {
        resource: key.split('::')[0],
        action: key.split('::')[1],
    };
}
